import { jsx } from '@emotion/react/jsx-runtime';
import { compound, createPolymorphicComponent } from '@nettbureau/core';
import { Item } from './item.js';
import { Stack } from './stack.js';

/**
 * A stack component with a predefined horizontal direction.
 */ const VStack = compound('VStack', createPolymorphicComponent((props, ref)=>{
    const { children, ...otherProps } = props;
    return /*#__PURE__*/ jsx(Stack, {
        ...otherProps,
        ref: ref,
        direction: "vertical",
        children: children
    });
}), {
    Item
});

export { VStack };
//# sourceMappingURL=v-stack.js.map
